module.exports = __webpack_public_path__ + "static/img/brees-2001-slide-5.dfbe7e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2001-slide-5.jpg
// module id = fG1k
// module chunks = 1